import React from "react";
import moment from "moment";
import Box from "../../../../components/box";
import Main from "../../../../components/main";
import Button from "../../../../components/button";
import "./styles.css";

export default class SaleBanner extends React.Component {
  state = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  componentWillMount() {
    this.saleCountdownInterval = setInterval(() => {
      const now = moment.utc();
      const end = moment.utc("2021-01-10", "YYYY-MM-DD"); // another date
      const duration = moment.duration(end.diff(now));

      //Get Days and subtract from duration
      let days = parseInt(duration.asDays());
      duration.subtract(moment.duration(days, "days"));
      if (days < 10 && days >= 0) days = "0" + days;

      //Get hours and subtract from duration
      let hours = parseInt(duration.hours());
      duration.subtract(moment.duration(hours, "hours"));
      if (hours < 10 && hours >= 0) hours = "0" + hours;

      //Get Minutes and subtract from duration
      let minutes = parseInt(duration.minutes());
      duration.subtract(moment.duration(minutes, "minutes"));
      if (minutes < 10 && minutes >= 0) minutes = "0" + minutes;

      //Get seconds
      let seconds = parseInt(duration.seconds());
      if (seconds < 10 && seconds >= 0) seconds = "0" + seconds;

      this.setState({
        days,
        hours,
        minutes,
        seconds,
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.saleCountdownInterval);
  }

  render() {
    const { days, hours, minutes, seconds } = this.state;
    const { loggedIn, premium, signInWithGoogle, fromClickTest } = this.props;
    return (
      <div className="salebanner">
        <Box>
          <Main>
            <div className="flex">
              <div className="saletext">
                <h3 style={{ marginTop: 0 }}>
                  {/* Get Ghast for only{" "}
                  <span
                    style={{
                      textDecoration: "line-through",
                      paddingRight: "5px",
                    }}
                  >
                    $15
                  </span>
                  $10 and Cyclone for ! */}
                  33% Off on both Ghast and Cyclone!
                </h3>
                <div className="buywrap">
                  <Button
                    href={
                      fromClickTest && loggedIn
                        ? "checkout"
                        : loggedIn
                        ? "#pricing"
                        : undefined
                    }
                    onClick={loggedIn ? undefined : signInWithGoogle}
                  >
                    {loggedIn
                      ? premium
                        ? "DOWNLOAD"
                        : "BUY NOW"
                      : "GET STARTED"}
                  </Button>
                </div>
              </div>
              <div className="salecountdown">
                <h4 style={{ marginBottom: 0 }}>
                  Christmas sale ends in (estimated)
                </h4>
                <div className="times" style={{ marginBottom: 16 }}>
                  <div className="timechild">
                    <span>{days}</span>
                    <span>Days</span>
                  </div>
                  <div className="timechild">
                    <span>{hours}</span>
                    <span>Hours</span>
                  </div>
                  <div className="timechild">
                    <span>{minutes}</span>
                    <span>Minutes</span>
                  </div>
                  <div className="timechild">
                    <span>{seconds}</span>
                    <span>Seconds</span>
                  </div>
                </div>
              </div>
            </div>
          </Main>
        </Box>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/pages/home/sections/saleBanner/index.js
 **/